import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {GlobalService} from './global.service';
import {ModalService} from './modal.service';
import {FtaService} from './fta.service';

import {UtilApi} from './api/util.api';
import {AutenticacaoApiService} from './api/autenticacao.api';
import {CatalogoApiService} from './api/catalogo.api';
import {ConstantesApiService} from './api/constantes.api';
import {DetalhamentoApiService} from './api/detalhamento.api';
import {PesquisasFiltroApiService} from './api/pesquisas-filtro.api';

@NgModule({
    imports: [
        HttpClientModule
    ],
    declarations: [],
    providers: [
        UtilApi,
        ModalService,
        GlobalService,
        FtaService,
        AutenticacaoApiService,
        AutenticacaoApiService,
        CatalogoApiService,
        ConstantesApiService,
        DetalhamentoApiService,
        PesquisasFiltroApiService
    ]
})
export class ServiceModule {
}



// WEBPACK FOOTER //
// ./src/service/service.module.ts